var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5759 20.25H4.42586C4.24131 20.2491 4.06339 20.1811 3.92536 20.0586C3.78733 19.9361 3.69864 19.7675 3.67586 19.5844L2.34461 7.58438C2.33277 7.47982 2.34306 7.37394 2.37482 7.27363C2.40658 7.17331 2.45909 7.0808 2.52894 7.0021C2.59879 6.92341 2.68442 6.8603 2.78026 6.81686C2.8761 6.77343 2.98001 6.75065 3.08523 6.75H20.9165C21.0217 6.75065 21.1256 6.77343 21.2215 6.81686C21.3173 6.8603 21.4029 6.92341 21.4728 7.0021C21.5426 7.0808 21.5951 7.17331 21.6269 7.27363C21.6587 7.37394 21.6689 7.47982 21.6571 7.58438L20.3259 19.5844C20.3031 19.7675 20.2144 19.9361 20.0764 20.0586C19.9383 20.1811 19.7604 20.2491 19.5759 20.25V20.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75V6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75V9.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.4c6e6ce9efc69a853dd181d6cf8d05aa.svg";
export { ForwardRef as ReactComponent };